import { HashLink } from "react-router-hash-link";
import { useDispatch } from "react-redux";
import { updateState } from "../../counter/counterSlice";
import { getGuidelineList } from "../../../utils/getConstants";
import classNames from "classnames";
import styles from "./TablesAndFigures.module.scss";

const getTablesAndFiguresTopicFileName = (text) => {
  return text.toLowerCase().replaceAll(" ", "-") + "-tables-boxes-figures";
};

const getDestination = (onClickProps) => {
  const topicFileName = getTablesAndFiguresTopicFileName(onClickProps);
  return (
    "/viewTopic?etgAccess=true&guidelinePage=" +
    encodeURIComponent(onClickProps) +
    "&topicfile=" +
    encodeURIComponent(topicFileName)
  );
};

const TablesAndFigures = () => {
  const glList = getGuidelineList();
  const ulClassName = classNames("list-unstyled", styles.guidelineAreas);
  const dispatch = useDispatch();
  const goToTable = (tableName, guidelineName) => {
    const guidelinePage = guidelineName.replace(/ /g, "_");
    const data = {
      ditaPath: `${guidelinePage}/`,
      queryString: {
        guidelinePage: encodeURIComponent(guidelineName),
        etgAccess: "true",
        topicfile: tableName,
      },
      XRefPath: `${guidelinePage}/tandf`,
      openSection: `${guidelinePage}/tandf`,
      displayBanner: true,
    };

    dispatch(updateState(data));
  };

  return (
    <ul
      className={ulClassName}
      role="navigation"
      aria-label="Tables and Figures Guidelines Navigation"
    >
      {glList.map(({ iconClassSuffix, linkText, onClickProps }, index) => (
        <li key={`ind-${index}`}>
          <span className={`squareIcon ${iconClassSuffix}`}></span>
          <HashLink
            alt=""
            data-toggle="tooltip"
            aria-label={linkText}
            to={getDestination(onClickProps)}
            onClick={() => goToTable(getTablesAndFiguresTopicFileName(onClickProps), onClickProps)}
          >
            {linkText}
            <span className="goto-arrow">
              <i className="fa banner-head-topic fa-angle-right"></i>
            </span>
          </HashLink>
        </li>
      ))}
      {!glList?.length && <div>No guidelines available.</div>}
    </ul>
  );
};

export default TablesAndFigures;
